export class FinalDataModel {
  solicitation_completed: boolean;
}
